import { IQueryParams } from '../types';

export const parseQueryString = (value: string): IQueryParams => {
  return value.split('&').reduce((queryObject, keyvalue: string) => {
    const [key, value] = keyvalue
      .split('=')
      .map((val) => decodeURIComponent(val));

    return {
      ...queryObject,
      [key]: value,
    };
  }, {});
};

export const getQueryString = (fullUrl: string): string => {
  const startIndex = fullUrl.indexOf('?');

  return startIndex >= 0 ? fullUrl.substr(startIndex + 1) : '';
};

export const getUrlPart = (fullUrl: string): string => {
  const endIndex = fullUrl.indexOf('?');
  return endIndex > 0 ? fullUrl.substr(0, endIndex) : fullUrl;
};

export const readValueFromQueryData = (
  queryData: IQueryParams,
  key: string
) => {
  const keys = Object.keys(queryData);

  if (keys.includes(key)) {
    return queryData[key];
  }
  return undefined;
};

export const getQueryValueFromQueryString = (query: string, key: string) => {
  const queryParams = parseQueryString(query);
  if (!queryParams) {
    return undefined;
  }
  return readValueFromQueryData(queryParams, key);
};

export const getQueryValueFromFullUrl = (fullUrl: string, key: string) => {
  const queryString = getQueryString(fullUrl);
  if (!queryString) {
    return undefined;
  }
  return getQueryValueFromQueryString(queryString, key);
};

export const splitOutQueryParams = (url?: string | null): [string, string] => {
  if (!url) {
    return ['', ''];
  }
  const queryString = getQueryString(url);
  const urlPart = getUrlPart(url);

  return [urlPart, queryString];
};
